import { datadogRum } from 'root/datadog/datadogRum';

interface InvoiceMetricData {
  actionName: string;
  saleID: string | number;
  startTime: number;
  numberOfPayments: number;
  numberOfDepositPayments: number;
  numberOfItems: number;
  apiVersion?: 'legacy' | 'v1';
}

/**
 * Logs an invoice-related metric to DataDog RUM
 * @param data - The metric data to log
 */
export function logInvoiceCreationMetric(data: InvoiceMetricData) {
  const endTime = new Date(Date.now()).getTime();
  const duration = Math.abs(data.startTime - endTime) / 1000;

  datadogRum.addAction(data.actionName, {
    saleID: data.saleID,
    accountID: window.merchantos.session.getSystemCustomerID(),
    duration,
    numberOfPayments: data.numberOfPayments,
    numberOfDepositPayments: data.numberOfDepositPayments,
    numberOfItems: data.numberOfItems,
    ...(data.apiVersion && { apiVersion: data.apiVersion }),
  });
}
